import React, { FunctionComponent } from 'react'
import { Link, Navigate, Route, Routes } from 'react-router-dom'
import { HostData } from '../Customer/Data'
import { HealthCheckBrief } from './HealthCheckBrief'
import styles from './BriefsHub.module.css'

interface Props {
  teamID: string
  host: HostData
}

const BriefsList: FunctionComponent = () => (
  <div>
    <header className={styles.header}>
      <h2>Briefs</h2>
      <p>Curated, point-in-time views of the customer's PaperCut deployment.</p>
    </header>
    <div className={`surface ${styles.tile}`}>
      <h4 className={styles.title}>
        <Link to='health-check'>Health check</Link>
      </h4>
      <p className={styles.description}>Contract status and product timeline at a glance.</p>
    </div>
  </div>
)

export const BriefsHub: FunctionComponent<Props> = ({ teamID, host }) => (
  <Routes>
    <Route index element={<BriefsList />} />
    <Route path='health-check' element={<HealthCheckBrief teamID={teamID} host={host} />} />
    <Route path='*' element={<Navigate to='.' replace />} />
  </Routes>
)
